import { PixelCrop } from 'react-image-crop'

const TO_RADIANS = Math.PI / 180




export async function canvasPreview(
  image: HTMLImageElement,
  canvas: HTMLCanvasElement,
  crop: PixelCrop,
  scale = 1,
  rotate = 0,
  overlay: HTMLImageElement,
  offset: number,
  hoverOverlaySrc: string | null,
  hoverOffset: number | null,
  herotFilterTransp: number,
  herotFilterColor: string,
  herotFilterActive: boolean,
  backgroundColor: string,
  horizontalMovePercentage: number,
  verticalMovePercentage: number,
  hoverHorizontalMovePercentage: any,
  hoverVerticalMovePercentage: any,
) {
  const ctx = canvas.getContext('2d')
  let curHrMovePercentage = hoverHorizontalMovePercentage !== null ? hoverHorizontalMovePercentage : horizontalMovePercentage;
  let curVrMovePercentage = hoverVerticalMovePercentage !== null ? hoverVerticalMovePercentage : verticalMovePercentage;

  if (!ctx) {
    throw new Error('No 2d context')
  }

  //console.log('offset:', offset);
  //console.log('hoverOffset:', hoverOffset);

  const scaleX = image.naturalWidth / image.width
  const scaleY = image.naturalHeight / image.height
  // devicePixelRatio slightly increases sharpness on retina devices
  // at the expense of slightly slower render times and needing to
  // size the image back down if you want to download/upload and be
  // true to the images natural size.
  const pixelRatio = window.devicePixelRatio
  // const pixelRatio = 1

  canvas.width = Math.floor(crop.width * scaleX * pixelRatio)
  canvas.height = Math.floor(crop.height * scaleY * pixelRatio)

  ctx.scale(pixelRatio, pixelRatio)
  ctx.imageSmoothingQuality = 'high'

  const cropX = crop.x * scaleX
  const cropY = crop.y * scaleY

  const rotateRads = rotate * TO_RADIANS
  const centerX = image.naturalWidth / 2
  const centerY = image.naturalHeight / 2



  ctx.save()

  const scaleTransparencyX = image.naturalWidth / image.width;
  const scaleTransparencyY = image.naturalHeight / image.height;

  // Calculate the center and radius for the circle
  const centerTransparentX = (crop.width / 2) * scaleTransparencyX;
  const centerTransparentY = (crop.width / 2) * scaleTransparencyY;
  const radius = crop.width / 2 * (hoverOffset !== null ? hoverOffset : offset) * scaleTransparencyX;

  // Calculate the center and radius for the background circle
  const backgroundCenterX = (crop.width / 2) * scaleTransparencyX;
  const backgroundCenterY = (crop.width / 2) * scaleTransparencyY;



  const backgroundRadius = crop.width / 2 * (hoverOffset !== null ? hoverOffset : offset) * scaleTransparencyX;

  // Start a new path for the background circle
  ctx.beginPath()

  // Draw a circle in the middle of the rectangle
  //ctx.arc(backgroundCenterX, backgroundCenterY, backgroundRadius, 0, 2 * Math.PI, false)
  ctx.arc(backgroundCenterX + (canvas.width * ( curHrMovePercentage / 500)), backgroundCenterY + (canvas.height * (curVrMovePercentage / 500)), backgroundRadius, 0, 2 * Math.PI, false)
  // Set the fill style to red
  ctx.fillStyle = backgroundColor

  // Fill the circle
  ctx.fill()


  // 5) Move the crop origin to the canvas origin (0,0)
  ctx.translate(-cropX, -cropY)
  // 4) Move the origin to the center of the original position
  ctx.translate(centerX, centerY)
  // 3) Rotate around the origin
  ctx.rotate(rotateRads)
  // 2) Scale the image
  ctx.scale(scale, scale)
  // 1) Move the center of the image to the origin (0,0)
  ctx.translate(-centerX, -centerY)
  ctx.drawImage(
    image,
    0,
    0,
    image.naturalWidth,
    image.naturalHeight,
    0,
    0,
    image.naturalWidth,
    image.naturalHeight,
  )

  ctx.restore()






  // Create an off-screen canvas
  const offscreenCanvas = document.createElement('canvas');
  offscreenCanvas.width = Math.max(1000);
  offscreenCanvas.height = Math.max(1000);
  const offscreenCtx = offscreenCanvas.getContext('2d')!;



  // Set the globalCompositeOperation to 'destination-out' so the new shape removes parts of the existing content
  ctx.globalCompositeOperation = 'destination-out'

  // Start a new path
  ctx.beginPath()

  // Draw a large rectangle that covers the entire canvas
  ctx.rect(0, 0, image.naturalWidth, image.naturalHeight)


  // Draw a circle in the middle of the rectangle. The 'counter-clockwise' parameter is set to true, so the circle is drawn in the opposite direction and cuts a hole in the rectangle
  //ctx.arc(centerTransparentX, centerTransparentY, radius, 0, 2 * Math.PI, true)
  ctx.arc(centerTransparentX + (canvas.width * (curHrMovePercentage / 500)), centerTransparentY + (canvas.height * (curVrMovePercentage / 500)), radius, 0, 2 * Math.PI, true)
  // Close the path
  ctx.closePath()

  // Fill the shapes to apply them
  ctx.fill()

  // Reset the globalCompositeOperation to 'source-over' so subsequent drawings are not affected
  ctx.globalCompositeOperation = 'source-over'

  // Restore the context to its original state
  ctx.restore()

  ctx.save()



  // Draw the overlay image on the off-screen canvas at its natural size
  offscreenCtx.drawImage(
    overlay,
    0,
    0,
    overlay.naturalWidth,
    overlay.naturalHeight,
    0,
    0,
    1000,
    1000
  );

  // If herotFilterActive is true, apply the filter
  if (herotFilterActive) {
    // Set the composite operation
    offscreenCtx.globalCompositeOperation = 'source-atop';

    // Set the color of the filter
    offscreenCtx.fillStyle = `${herotFilterColor.slice(0, -1)}, ${herotFilterTransp})`;

    // Apply the filter
    offscreenCtx.fillRect(0, 0, offscreenCanvas.width, offscreenCanvas.height);

    // Reset the composite operation
    offscreenCtx.globalCompositeOperation = 'source-over';
  }

  // Draw the off-screen canvas (with the filtered overlay) onto the main canvas
  ctx.drawImage(offscreenCanvas, 0, 0, canvas.width / pixelRatio, canvas.height / pixelRatio);

}
